import * as React from "react";
import { uniq } from "../../utils/arrays.js";
function useMyValidationErrorMessages(bind, validationErrorMessages) {
  return React.useMemo(() => {
    var _a;
    return uniq([...validationErrorMessages ?? [], ...((_a = bind == null ? void 0 : bind.myValidationErrors) == null ? void 0 : _a.map((error) => error.message)) ?? []]);
  }, [validationErrorMessages, bind == null ? void 0 : bind.myValidationErrors]);
}
export {
  useMyValidationErrorMessages
};
//# sourceMappingURL=useMyValidationErrorMessages.js.map
